import React, { useEffect, useState } from 'react'
import { CButton, CCard, CCardBody, CCardHeader, CCollapse, CSmartTable } from '@coreui/react-pro'
import moment from 'moment'
import { toast } from 'react-toastify'
import ToastComponent from 'src/components/common/TaostComponent.js'
import EditForm from './EditForm'
import Notify from '../Notify'
import AdsManagerService from 'src/service/AdsManagerService'

const AdminPromoTable = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnFilter,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnFilter,
  columnSorter,
}) => {
  const [loading, setLoading] = useState()
  const [visibleHorizontal, setVisibleHorizontal] = useState(false)
  const [selectedId, setSelectedId] = useState(0)
  const [details, setDetails] = useState([])
  const columns = [
    {
      label: 'Logo',
      key: 'logo',
      filter: false,
      sorter: false,
    },
    { label: 'Promo Title', filter: true, key: 'title' },
    { label: 'Promo Label', filter: true, key: 'promo_label' },
    { label: 'Promo Validity', filter: false, key: 'validity_date' },
    {
      label: 'Promo Start Date',
      filter: false,
      key: 'schedule_start_date',
    },
    {
      label: 'Promo End Date',
      filter: false,
      key: 'schedule_end_date',
    },
    {
      key: 'show_details',
      label: 'Actions',
      _style: { width: '1%' },
      filter: false,
      sorter: false,
    },
  ]

  const toggleDetails = (index) => {
    setSelectedId(index)
    const position = details.indexOf(index)
    let newDetails = details.slice()
    if (position !== -1) {
      newDetails.splice(position, 1)
    } else {
      newDetails = [...details, index]
    }
    setDetails(newDetails)
  }

  const deleteAds = (id) => {
    setLoading(true)
    const data = { id }
    const position = details.indexOf(id)
    let newDetails = details.slice()
    newDetails.splice(position, 1)
    setDetails(newDetails)
    AdsManagerService.deleteAds(data).then((res) => {
      if (res.status === 200) {
        toast.dismiss()
        fetchUsers()
        ToastComponent(res.message, 'success')
        setLoading(false)
      }
    })
  }

  const handleEdit = (id) => {
    setSelectedId(id)
  }

  const [handleYes, setHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)

  const handleCancel = () => setShowConfirm(false)

  const handleConfirm = () => {
    deleteAds(tableId)
    setShowConfirm(false)
  }

  const areYouSureModal = (id) => {
    setShowConfirm(true)
    setTableId(id)
  }

  useEffect(() => {
    fetchUsers()
  }, [activePage, columnFilter, columnSorter, itemsPerPage, fetchUsers])

  return (
    <>
      <CSmartTable
        columns={columns}
        columnFilter={{
          external: true,
        }}
        columnSorter={{
          external: true,
        }}
        scopedColumns={{
          logo: (item) => (
            <td>
              {item.logo && (
                <img
                  src={`${process.env.REACT_APP_API_URL}uploads/ads/${item.logo}`}
                  alt="promo"
                  width="50"
                  height="50"
                />
              )}
            </td>
          ),
          validity_date: (item) => <td>{moment(item.validity_date).format('D.MM.YYYY')}</td>,
          schedule_start_date: (item) => (
            <td>{moment(item.schedule_start_date).format('D.MM.YYYY')}</td>
          ),
          schedule_end_date: (item) => (
            <td>{moment(item.schedule_end_date).format('D.MM.YYYY')}</td>
          ),
          show_details: (item) => (
            <td className="py-2">
              <CButton
                color="primary"
                variant="outline"
                shape="square"
                size="sm"
                onClick={() => toggleDetails(item.id)}
              >
                {details.includes(item.id) ? 'Hide' : 'Manage'}
              </CButton>
            </td>
          ),
          details: (item) => (
            <CCollapse visible={details.includes(item.id)}>
              <CCardBody>
                <CButton
                  size="sm"
                  color="success"
                  className="ml-1"
                  onClick={() => {
                    setVisibleHorizontal(!visibleHorizontal)
                    handleEdit(item.id)
                  }}
                  aria-expanded={visibleHorizontal}
                  aria-controls="collapseEdit"
                >
                  Edit
                </CButton>
                <CButton
                  size="sm"
                  color="danger"
                  className="ml-1"
                  onClick={() => areYouSureModal(item.id)}
                >
                  Delete
                </CButton>
                <CCollapse id="collapseEdit" horizontal visible={visibleHorizontal}>
                  <CCard className="mb-4">
                    <CCardHeader>
                      <strong>Edit Promo Card</strong>
                    </CCardHeader>
                    <CCardBody>
                      <EditForm
                        sponsorId={item.id}
                        selectedId={selectedId}
                        visibleHorizontal={visibleHorizontal}
                        fetchUsers={fetchUsers}
                        toggleDetails={toggleDetails}
                      />
                    </CCardBody>
                  </CCard>
                </CCollapse>
              </CCardBody>
            </CCollapse>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{
          external: true,
        }}
        paginationProps={{
          activePage: activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{
          hover: true,
          responsive: true,
        }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this?"
      />
    </>
  )
}

export default AdminPromoTable
